var _NistObjectIdentifiers = /** @class */ (function () {
    function _NistObjectIdentifiers() {
        this._secureHash256AlgorithmIdentifier = { id: '2.16.840.1.101.3.4.2.1' }; //eslint-disable-line
        this._secureHash384AlgorithmIdentifier = { id: '2.16.840.1.101.3.4.2.2' }; //eslint-disable-line
        this._secureHash512AlgorithmIdentifier = { id: '2.16.840.1.101.3.4.2.3' }; //eslint-disable-line
        this._raceEvaluationMessageDigestAlgorithmIdentifier = { id: '1.3.36.3.2.1' }; //eslint-disable-line
        this._digitalSignatureWithSecureHash256AlgorithmIdentifier = { id: '2.16.840.1.101.3.4.3.2' }; //eslint-disable-line
        this._ronCipherWithRaceEvaluationAlgorithmIdentifier = { id: '1.3.36.3.3.1.2' }; //eslint-disable-line
    }
    return _NistObjectIdentifiers;
}());
export { _NistObjectIdentifiers };
var _PdfCryptographicObjectIdentifier = /** @class */ (function () {
    function _PdfCryptographicObjectIdentifier() {
        this._messageDigest5 = { id: '1.2.840.113549.2.5' }; //eslint-disable-line
        this._secureHash1WithRonCipherEncryption = { id: '1.2.840.113549.1.1.5' }; //eslint-disable-line
        this._secureHash256WithRonCipherEncryption = { id: '1.2.840.113549.1.1.11' }; //eslint-disable-line
        this._secureHash384WithRonCipherEncryption = { id: '1.2.840.113549.1.1.12' }; //eslint-disable-line
        this._secureHash512WithRonCipherEncryption = { id: '1.2.840.113549.1.1.13' }; //eslint-disable-line
        this._messageDigest2WithRonCipherEncryption = { id: '1.2.840.113549.1.1.2' }; //eslint-disable-line
        this._raceEvaluationEncryption = { id: '1.2.840.113549.1.1.1' }; //eslint-disable-line
    }
    return _PdfCryptographicObjectIdentifier;
}());
export { _PdfCryptographicObjectIdentifier };
var _PdfDigitalIdentifiers = /** @class */ (function () {
    function _PdfDigitalIdentifiers() {
        this._cryptographicData = '1.2.840.113549.1.7.1';
        this._cryptographicSignedData = '1.2.840.113549.1.7.2';
        this._rsaEncryption = '1.2.840.113549.1.1.1';
        this._dsaSignature = '1.2.840.10040.4.1';
        this._ecPublicKey = '1.2.840.10045.2.1';
        this._contentType = '1.2.840.113549.1.9.3';
        this._messageDigest = '1.2.840.113549.1.9.4';
        this._signingCertificate = '1.2.840.113549.1.9.16.2.47';
        this._revocation = '1.2.840.113583.1.1.8';
    }
    return _PdfDigitalIdentifiers;
}());
export { _PdfDigitalIdentifiers };
